import { Component, inject, LOCALE_ID, Inject } from '@angular/core';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule, registerLocaleData } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { ThemeSwitcherComponent } from '../comp/theme-switcher/theme-switcher.component';
import { navigation, NavigationItem } from './navigation';
import { SessionService } from '@yukawa/chain-main-angular-session';
import localeEn from '@angular/common/locales/en';
import localeDe from '@angular/common/locales/de';

@Component({
  selector: 'app-layout',
  imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatMenuModule,
    MatDividerModule,
    TranslocoDirective,
    ThemeSwitcherComponent
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent {
  isMobileMenuOpen = false;
  sessionService = inject(SessionService);
  translocoService = inject(TranslocoService);
  private currentLocale = 'de';

  constructor() {
    // Register locales
    registerLocaleData(localeEn, 'en');
    registerLocaleData(localeDe, 'de');
  }

  get currentUsername() {
    return this.sessionService.session?.user?.name || 'unknown';
  }

  get availableLanguages() {
    return this.translocoService.getAvailableLangs() as { id: string; label: string }[];
  }

  get currentLanguage() {
    return this.translocoService.getActiveLang();
  }

  changeLanguage(lang: string): void {
    this.translocoService.setActiveLang(lang);
    this.currentLocale = lang;
    // Force reload to apply new locale
    window.location.reload();
  }

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
  }

  onDrawerChange(opened: boolean): void {
    this.isMobileMenuOpen = opened;
  }

  get navigationItems(): NavigationItem[] {
    return navigation;
  }
}
